export const enum RoutesEnum {
  SEARCH_RESULTS = 'SearchResults',
  SEARCH_WIDGET = 'SearchWidget',
  CAR_DETAILS = 'CarDetails',
  COMPARE_VEHICLES = 'CompareVehicles',
  EXP_REVIEWS = 'ExpertReviews',
  TESTING = 'Testing',
}

export const routeMappings: Record<string, string> = {
  [RoutesEnum.SEARCH_WIDGET]: 'components/search',
  [RoutesEnum.SEARCH_RESULTS]: 'views',
  [RoutesEnum.CAR_DETAILS]: 'views',
  [RoutesEnum.COMPARE_VEHICLES]: 'views',
  [RoutesEnum.EXP_REVIEWS]: 'views',
  [RoutesEnum.TESTING]: 'views',
};
